export enum Weekdays {
  SATURDAY = 'saturday',
  SUNDAY = 'sunday',
  MONDAY = 'monday',
  TUESDAY = 'tuesdau',
  WEDNSDAY = 'wednsday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
}
